export function AppMode() {
  return <div id="jane-app-mode" data-appmode="bloom"></div>;
}
